import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Col, Row, Modal } from "react-bootstrap";
import logo from "../Images/logo.svg";
import { FcGoogle } from "react-icons/fc";
import "./Navbar.css";
import Trialcards from "./Trial";

const Main = () => {
  const [showVideo, setShowVideo] = useState(false);

  const handleOpenVideo = () => setShowVideo(true);
  const handleCloseVideo = () => setShowVideo(false);
  return (
    <>
      <Row
        className="d-flex justify-content-center mx-md-0 mx-2 "
        style={{ height: "" }}
      >
        <Col className="mb-5" md={10}>
          <Row className="mt-5" style={{ height: "" }}>
            <Col
              md={6}
              className="d-flex flex-column justify-content-center align-items-start"
            >
              <div>
                <h1 className="responsive-heading">
                  <b>
                    Track, <span style={{ color: "#3C74F6" }}>Analyze</span> &
                    Grow
                    <br />
                    <span style={{ color: "#3C74F6" }}>Digitally</span> with
                    SeoBix
                  </b>
                </h1>

                <p
                  className="mt-3"
                  style={{
                    color: "#00013C",
                    fontSize: "1rem",
                    fontWeight: "500",
                  }}
                >
                  SeoBix offers you every essential SEO tool in one place <br />
                  By saving your time, effort, and confusion. <br />A whole
                  toolkit that combines traffic analytics, ON-page SEO <br />
                  and many more.
                </p>
                <div className="mt-4 d-flex gap-3">
                  <Button
                    onClick={() =>
                      window.open("https://dashboard.seobix.com/", "_blank")
                    }
                    style={{
                      backgroundColor: "#fff",
                      color: "#0D0D26",
                      border: "2px solid #3C74F6",
                      fontWeight: 600,
                      padding: "10px 20px",
                      fontSize: "1rem",
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <FcGoogle size={20} />
                    <span>Start free with Google</span>
                  </Button>

                  <Button
                    onClick={() =>
                      window.open("https://dashboard.seobix.com/", "_blank")
                    }
                    style={{
                      backgroundColor: "#fff",
                      color: "#0D0D26",
                      border: "2px solid #3C74F6",
                      fontWeight: 600,
                      padding: "10px 20px",
                      fontSize: "1rem",
                    }}
                  >
                    Book a Demo
                  </Button>
                </div>
              </div>
            </Col>
            <Col
              md={6}
              className="d-flex justify-content-center align-items-center mt-md-5 "
              style={{ height: "100%" }}
            >
              <div
                className="image-hover-wrapper"
                style={{ cursor: "pointer" }}
                onClick={handleOpenVideo}
              >
                <img
                  src={require("../Images/mainbannerforvideo.webp")}
                  alt="Tool"
                  className="-image"
                  style={{ height: "45vh" }}
                />
                <img
                  src={require("../Images/watch.gif")}
                  alt="Watch GIF"
                  className="hover-gif"
                />
              </div>
            </Col>
            {/* <Col
              md={6}
              className="d-flex justify-content-center align-items-center mt-md-5 "
              style={{ height: "100%" }}
            >
              <div
                className="image-hover-wrapper"
                style={{ cursor: "pointer" }}
             >
                <img
                  src={require("../Images/mainbannerforvideo.webp")}
                  alt="Tool"
                  className="-image"
                  style={{ height: "45vh" }}
                />
            
              </div>
            </Col> */}
          </Row>
        </Col>
      </Row>

      <Modal
        show={showVideo}
        onHide={handleCloseVideo}
        centered
        size="lg"
        style={{ zIndex: 9999 }}
        dialogClassName="video-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {" "}
            <img src={logo} alt="Logo" style={{ height: "3rem" }} />
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex justify-content-center align-items-center p-0">
          <video
            width="100%"
            height="auto"
            controls
            autoPlay
            style={{
              borderBottomRightRadius: "1rem",
              borderBottomLeftRadius: "1rem",
            }}
          >
            <source src={require("../Images/video.mp4")} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Main;
